import { LOCAL_STORAGE_GRID_KEYS } from "../../../_constants";
import { formatDate, QuestionnaireStatus } from "../../../_helpers";
import { getGridContextMenuList } from "../../../_helpers/getGridContextMenuList";
import { LabelColumnV2, LinkColumnV2 } from "../../../components/DataGridV2/DataColumnsV2";

export const getQuestionnaireColumns = ({
    t,
    handleCellSort,
    handleCellFilter,
    i18n,
    apiRef,
    keyPrefix,
}) => {
    const getOptions = getGridContextMenuList({
        handleCellSort,
        handleCellFilter,
        filterKey: LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        getValueForFilter: (rowData, extraData) => {
            let value = ""
            switch (extraData.fieldName) {
                case "date":
                    value = formatDate(new Date(rowData.date)).split("-").reverse().join("-")
                    break;
                case "questionnaireStatus":
                    value = rowData?.questionnaireStatus?.toString()
                    break;
                default:
                    value = rowData[extraData.fieldName]
                    break;
            }
            return value
        },
        getValueForCopy: (rowData, extraData) => {
            let text = ""
            switch (extraData.fieldName) {
                case "plannedDate":
                    text = rowData.plannedDate ? formatDate(new Date(rowData.plannedDate)) : "-"
                    break;
                case "createdOn":
                    text = rowData.createdOn ? formatDate(new Date(rowData.createdOn)) : "-"
                    break;
                case "completedOn":
                    text = rowData.completedOn ? formatDate(new Date(rowData.completedOn)) : "-"
                    break;
                case "questionnaireStatus":
                    text = t(`questionnaire.status.${rowData.questionnaireStatus}`)
                    break;
                default:
                    text = rowData[extraData.fieldName]
                    break;
            }
            return text
        }
    })
    return [

        {
            field: "projectNoAndName",
            download: true,
            headerName: t('general.projectNumber'),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params?.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2 label={rowData.projectNoAndName}
                        cellSubMenuOptions={{ options: getOptions({ field: "projectNoAndName", isQuickFilterDisplay: Boolean(rowData.projectNoAndName) }), extraData: { fieldName: "projectNoAndName" } }}
                        request={params?.row}
                    />
                )
            },
        },
        {
            field: "buildingNoIntern",
            download: true,
            headerName: t('general.buildingNumber.internal'),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params?.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2 label={rowData.buildingNoIntern}
                        cellSubMenuOptions={{ options: getOptions({ field: "buildingNoIntern", isQuickFilterDisplay: Boolean(rowData.buildingNoIntern) }), extraData: { fieldName: "buildingNoIntern" } }}
                        request={params?.row}
                    />
                )
            },
        },
        {
            field: "name",
            download: true,
            headerName: t('questionnaire.name'),
            flex: 1,
            minWidth: 100,
            renderCell: (params) => {
                const rowData = params?.row;
                if (!rowData) return "";
                return (
                    <LinkColumnV2
                        to={`/vragenlijst/${rowData.id}`}
                        label={rowData.name}
                        cellSubMenuOptions={{ options: getOptions({ field: "name", isQuickFilterDisplay: Boolean(rowData.name) }), extraData: { fieldName: "name" } }}
                        request={rowData}
                    />
                )
            },
        },
        {
            field: "questionnaireTemplateName",
            download: true,
            headerName: t("questionnaire.template"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params?.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2
                        label={rowData.questionnaireTemplateName}
                        request={rowData}
                        cellSubMenuOptions={{ options: getOptions({ field: "questionnaireTemplateName", isQuickFilterDisplay: Boolean(rowData.questionnaireTemplateName) }), extraData: { fieldName: "questionnaireTemplateName" } }}
                    />
                )
            },
        },
        {
            field: "version",
            headerName: t('general.version'),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData.version}
                    cellSubMenuOptions={{ options: getOptions({ field: "version", isQuickFilterDisplay: Boolean(rowData.version) }), extraData: { fieldName: "version" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "createdOn",
            headerName: t('general.creationDate'),
            flex: 1,
            minWidth: 90,
            type: "dateTime",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData?.createdOn ? formatDate(new Date(rowData?.createdOn), true, "-", false) : ""}
                    cellSubMenuOptions={{ options: getOptions({ field: "createdOn", isQuickFilterDisplay: rowData?.createdOn }), extraData: { fieldName: "createdOn", type: "dateTime" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "executor",
            headerName: t('questionnaire.assignTo'),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.executor}
                        request={rowData}
                        cellSubMenuOptions={{
                            options: getOptions({ field: "executor", isQuickFilterDisplay: Boolean(rowData.executor) }),
                            extraData: { fieldName: "executor" }
                        }}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "addressPostcode",
            headerName: t("general.address.postcode"),
            flex: 1,
            align: "start",
            minWidth: 75,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return (
                    <LabelColumnV2
                        label={request.addressPostcode}
                        cellSubMenuOptions={{ options: getOptions({ field: "addressPostcode", isQuickFilterDisplay: Boolean(request.addressPostcode) }), extraData: { fieldName: "addressPostcode" } }}
                        request={request}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "addressText",
            headerName: t("general.objectAddress"),
            flex: 1,
            align: "start",
            editable: false,
            minWidth: 200,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return (
                    <LabelColumnV2
                        label={request.addressText}
                        cellSubMenuOptions={{ options: getOptions({ field: "addressText", isQuickFilterDisplay: Boolean(request.addressText) }), extraData: { fieldName: "addressText" } }}
                        request={request}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "addressPlace",
            headerName: t("general.address.city"),
            flex: 1,
            align: "start",
            editable: false,
            minWidth: 108,
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return (
                    <LabelColumnV2
                        label={request.addressPlace}
                        cellSubMenuOptions={{ options: getOptions({ field: "addressPlace", isQuickFilterDisplay: Boolean(request.addressPlace) }), extraData: { fieldName: "addressPlace" } }}
                        request={request}
                    />
                );
            },
        },
        {
            field: "plannedDate",
            headerName: t('questionnaire.plannedDateTime'),
            flex: 1,
            minWidth: 90,
            type: "dateTime",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData?.plannedDate ? formatDate(new Date(rowData?.plannedDate), true, "-", false) : ""}
                    cellSubMenuOptions={{ options: getOptions({ field: "plannedDate", isQuickFilterDisplay: rowData?.plannedDate }), extraData: { fieldName: "plannedDate", type: "dateTime" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "completedOn",
            headerName: t('questionnaire.completionDateAndTime'),
            flex: 1,
            minWidth: 90,
            type: "dateTime",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData?.completedOn ? formatDate(new Date(rowData?.completedOn), true, "-", false) : ""}
                    cellSubMenuOptions={{ options: getOptions({ field: "completedOn", isQuickFilterDisplay: rowData?.completedOn }), extraData: { fieldName: "completedOn", type: "dateTime" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "questionnaireStatus",
            download: true,
            headerName: t('general.status'),
            flex: 1,
            type: 'singleSelect',
            valueOptions: Object.values(QuestionnaireStatus).map((questionnaireStatusKey) => ({ value: questionnaireStatusKey.toString(), label: t(`questionnaire.status.${questionnaireStatusKey}`) })),
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params?.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2
                        label={t(`questionnaire.status.${rowData.questionnaireStatus}`)}
                        request={rowData}
                        cellSubMenuOptions={{
                            options: getOptions({ field: "questionnaireStatus", isQuickFilterDisplay: Boolean(rowData.questionnaireStatus.toString()) }), extraData: { fieldName: "questionnaireStatus", type: 'singleSelect' }
                        }}
                    />
                )
            },
        },
        {
            field: "noOfQuestions",
            download: true,
            headerName: t('questionnaire.numberOfQuestions'),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params?.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2
                        label={rowData.noOfQuestions}
                        request={rowData}
                        cellSubMenuOptions={{
                            options: getOptions({ field: "noOfQuestions", isQuickFilterDisplay: Boolean(rowData.noOfQuestions) }), extraData: { fieldName: "noOfQuestions" }
                        }}
                    />
                )
            },
        },

    ];
}
export const getQuestionnaireGridNavigationItem = (t) => {
    const to = "/vragenlijst"
    return {
        breadCrumbs: [{ breadCrumbTitle: t('constructionquality.questionnaire'), title: t('constructionquality.questionnaire'), to }],
        tabs: [{ title: t('general.list'), to }]
    }
}